<script lang="ts">
  // SvelteKit automatically passes params to pages, we don't use it but declare to suppress warnings
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export let params: Record<string, string> = {};
  
  import { goto } from '$app/navigation';
  import { onMount } from 'svelte';

  onMount(() => {
    goto('/client');
  });
</script>
